module.exports = __webpack_public_path__ + "static/media/DSC_0144.cb15da76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0144.jpg
// module id = 636
// module chunks = 0